/* eslint-disable react-hooks/exhaustive-deps */
import { NavbarTopAdmin, NavbarBottomAdmin } from '../admin/components'
import { useLocation, useNavigate, Link } from 'react-router-dom'
import { App, EventiItem, DivBottom, NavbarNotAuth, ImgRandomEventi } from './components'
import { useEffect, useState } from 'react'

function ViewEventi() {
    const location = useLocation()
    const navigate = useNavigate()
    const comune = location.state?.comune//input utente in ricerca per città
    const eventi = location.state?.evento//array eventi filtrati
    const status = location.state?.status//se la ricerca avviene con 'cerca per tipologia' status = 'fromSelect'
    let tipoEvento
    const [fotoDaScegliere, setFotoDaScegliere] = useState()

    if (eventi && eventi.length > 0) { tipoEvento = eventi[0].tipologia }

    window.scrollTo(0, 500)

    useEffect(() => {
        if (eventi === undefined) { navigate('/', { replace: true }) } else {
            setTimeout(() => {
                const df = document.getElementById('transitionOpacity')
                df.style.opacity = '1'
            }, 500)
        }
    }, [eventi])
    // useEffect(()=>{console.log(fotoDaScegliere)},[fotoDaScegliere])

    return (<>
        {localStorage.getItem('logged') ? <div><NavbarTopAdmin /> <NavbarBottomAdmin /></div>
            : <NavbarNotAuth />}
        <ImgRandomEventi onDataSubmit={(e) => { setFotoDaScegliere(e) }} />
        <div className='container-fluid' style={{ marginTop: '5em' }}>
            <p >\<b>Risultato della ricerca</b></p>
        </div>
        <App />
        <div className='container mt-5'>
            {/* se la ricerca avviene con 'cerca per città' manda a schermo la città */}
            {status !== 'fromSelect' && eventi &&
                <div>
                    <h5 className='text-center'>{comune.toUpperCase()}</h5>
                    {eventi.length === 1 ? <h5 className='text-center'>Trovato 1 evento</h5> :
                        eventi.length > 1 ? <h5 className='text-center'>Trovati {eventi.length} eventi</h5> :
                            eventi.length === 0 ? <h5 style={{ marginBottom: '15rem', textAlign: 'center' }}>NESSUN EVENTO TROVATO</h5> : null
                    }
                </div>
            }

            {/* se la ricerca avviene con 'cerca per tipologia' manda a schermo la tipologia */}
            {status === 'fromSelect' && eventi.length > 0 &&
                <div>
                    <h5 className='text-center'>{tipoEvento.toUpperCase()}</h5>
                    {eventi.length === 1 ? <h5 className='text-center'>Trovato 1 evento</h5> :
                        eventi.length > 1 ? <h5 className='text-center'>Trovati {eventi.length} eventi</h5> :
                            eventi.length === 0 ? <h5 style={{ marginBottom: '15rem', textAlign: 'center' }}>NESSUN EVENTO TROVATO</h5> : null
                    }
                </div>}

            <div className="row row-cols-1 row-cols-md-3 g-4 mt-3" id="transitionOpacity" style={{ opacity: '.3', transition: 'opacity .5s' }}>
                {eventi && fotoDaScegliere &&
                    eventi
                        .filter(item => (item.accettazione !== 'rejection'))
                        .filter(item => (item.accettazione !== 'false'))
                        .map(evento => {
                            let fotoScelta
                            if (!evento.img) {
                                const categoriaMatch = fotoDaScegliere.find(item => item.tipologia === evento.tipologia)
                                if (categoriaMatch && categoriaMatch.foto && categoriaMatch.foto.length > 0) {
                                    const arrayFoto = categoriaMatch.foto;
                                    const indiceCasuale = Math.floor(Math.random() * arrayFoto.length);
                                    fotoScelta = arrayFoto[indiceCasuale];
                                }
                                // fotoDaScegliere.map((item) => {
                                //     if (item.tipologia === evento.tipologia) {
                                //         const arrayFoto = item.foto // Prende l'array di foto corretto (es. le 3 di halloween)
                                //         const indiceCasuale = Math.floor(Math.random() * arrayFoto.length)
                                //         fotoScelta = arrayFoto[indiceCasuale]
                                //     } else fotoScelta = evento.img
                                // })
                            }
                            return (
                                <EventiItem
                                    key={evento.id}
                                    id={evento.id}
                                    userId={evento.userId}
                                    accettazione={evento.accettazione}
                                    comune={evento.comune}
                                    provincia={evento.provincia}
                                    dataInizio={evento.dataInizio}
                                    dataFine={evento.dataFine}
                                    descrizione={evento.descrizione}
                                    opzioniBiglietto={evento.opzioniBiglietto}
                                    oraFine={evento.oraFine}
                                    oraInizio={evento.oraInizio}
                                    prezzo={evento.prezzo}
                                    tipologia={evento.tipologia}
                                    titolo={evento.titolo}
                                    url={evento.url}
                                    img={evento.img}
                                    view={evento.view}
                                />
                            )
                        })}
            </div>
        </div>
        <h5 className='mt-5 text-center'>LUOGHI IMPERDIBILI IN ITALIA</h5>
        <div className='bodyPadding mt-3 text-center' style={{ overflow: 'auto', whiteSpace: 'nowrap', overflowY: 'hidden' }}>
            <Link to={{ pathname: "/venezia" }} style={{ textDecoration: 'none', color: 'black' }}>
                <img src={require("./image/claudio-schwarz-VlI9IQgMilw-unsplash.jpg")} width={130} height={100}
                    style={{ borderRadius: '20px', margin: '0.5rem' }} alt='' />
            </Link>
            <Link to={{ pathname: "/civita" }} style={{ textDecoration: 'none', color: 'black' }}>
                <img src={require("./image/gabriele-merlino-unsplash.jpg")} width={130} height={100}
                    style={{ borderRadius: '20px', margin: '0.5rem' }} alt='' />
            </Link>
            <Link to={{ pathname: "/firenze" }} style={{ textDecoration: 'none', color: 'black' }}>
                <img src={require("./image/alexandra-smielova-unsplash.jpg")} width={130} height={100}
                    style={{ borderRadius: '20px', margin: '0.5rem' }} alt='' />
            </Link>
            <Link to={{ pathname: "/roma" }} style={{ textDecoration: 'none', color: 'black' }}>
                <img src={require("./image/caleb-miller-0Bs3et8FYyg-unsplash.jpg")} width={130} height={100}
                    style={{ borderRadius: '20px', margin: '0.5rem' }} alt='' />
            </Link>
            <Link to={{ pathname: "/orvieto" }} style={{ textDecoration: 'none', color: 'black' }}>
                <img src={require("./image/mario-la-pergola-AeGitzwf3qw-unsplash.jpg")} width={130} height={100}
                    style={{ borderRadius: '20px', margin: '0.5rem' }} alt='' />
            </Link>
            <Link to={{ pathname: "/matera" }} style={{ textDecoration: 'none', color: 'black' }}>
                <img src={require("./image/moira-nazzari-BY25ED6PSJk-unsplash.jpg")} width={130} height={100}
                    style={{ borderRadius: '20px', margin: '0.5rem' }} alt='' />
            </Link>
        </div>
        <DivBottom />
    </>
    )
}
export default ViewEventi